import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getIdTokenResult, onAuthStateChanged } from 'firebase/auth';
import { auth } from './configs/Firebase';
import { ToastrProvider } from './context/ToastrContext';
import RoutePaths from './configs/Routes';
import theme from './styles/Theme';
import HomePage from './views/Home';
import AffiliateListPage from './views/affiliates/List';
import AffiliateDetailsPage from './views/affiliates/AffiliateDetails';
import LoginPage from './views/auth/Login';
import LogoutPage from './views/auth/Logout';
import { affiliateStatus } from './configs/Constants';
import BlogListPage from './views/blogs/List';
import CreateBlogPage from './views/blogs/Create';
import InventorySync from './views/InventorySync';

function App() {
  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Get the ID token result for the user
        const idTokenResult = await getIdTokenResult(user);

        // Check if the user has the custom claim 'isAdmin'
        if (idTokenResult?.claims?.isAdmin) {
          window.localStorage.setItem('isLoggedIn', true);
        } else {
          auth.signOut();
          window.localStorage.removeItem('isLoggedIn');
        }
      } else {
        // DO SOMETHING
        window.localStorage.removeItem('isLoggedIn');
      }
    });
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CssBaseline />
        <ToastrProvider>
          <Router>
            <Routes>
              <Route path={RoutePaths.HOME} element={<HomePage />} />
              <Route path={RoutePaths.AFFILIATES} element={<AffiliateListPage type={-1} />} />
              <Route path={RoutePaths.AFFILIATE_DETAILS} element={<AffiliateDetailsPage />} />
              <Route
                path={RoutePaths.AFFILIATES_PENDING_APPROVAL}
                element={<AffiliateListPage type={affiliateStatus.PENDING} />}
              />
              <Route
                path={RoutePaths.APPROVED_AFFILIATES}
                element={<AffiliateListPage type={affiliateStatus.APPROVED} />}
              />
              <Route path={RoutePaths.INVENTORYSYNC} element={<InventorySync />} />
              <Route path={RoutePaths.LOGIN} element={<LoginPage />} />
              <Route path={RoutePaths.BLOGS} element={<BlogListPage />} />
              <Route path={RoutePaths.CREATE_BLOG} element={<CreateBlogPage />} />
              <Route path={RoutePaths.EDIT_BLOG} element={<CreateBlogPage />} />
              <Route path={RoutePaths.LOGOUT} element={<LogoutPage />} />
            </Routes>
          </Router>
        </ToastrProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
